// extracted by mini-css-extract-plugin
module.exports = {"list":"List-module--list--1JBmm","orderedList":"List-module--orderedList--2bf9R"};